import React from 'react';
import OrderDelivery from './order-delivery';
import OrderTakeAway from './order-takeaway';

const OrderStartWrapper = (props) => {
  if (props.url.orderType === 'delivery') {
    return <OrderDelivery {...props} />;
  }
  return <OrderTakeAway {...props} />
}

export default OrderStartWrapper;



// WEBPACK FOOTER //
// ./src/containers/order/order-start-wrapper.js